import script from "./authors-filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./authors-filter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__